export default class AdminConsultations {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminConsultationRoute}`, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminConsultationRoute}/${id}`, {})
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminConsultationRoute}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminConsultationRoute}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}`, payload, {})
  }

  referToMedicalProfessional(id, payload = {}){
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}/refer-to-medical-professional`, payload, {})
  }
  
  referToExternal(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}/refer-to-external`, payload, {})
  }

  complete(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}/complete`, {})
  }

  cancel(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}/cancel`, {})
  }
  
  reopen(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}/reopen`, {})
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminConsultationRoute}/${id}`, {})
  }
}
